import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import * as CropsActions from './crops.actions';
import { Crop, CropsState } from '../../shared/model';

export const adapter: EntityAdapter<Crop> = createEntityAdapter<Crop>();
export const initialState: CropsState = adapter.getInitialState({});

export const cropsReducer = createReducer<CropsState>(
  initialState,
  on(CropsActions.loadCropsSuccess, (state, { crops }) => adapter.setAll(crops, state)),
);
